__turbopack_context__.v({
  "actions": "hero-slide-module__VBQ7kG__actions",
  "arrow": "hero-slide-module__VBQ7kG__arrow",
  "bullets": "hero-slide-module__VBQ7kG__bullets",
  "content": "hero-slide-module__VBQ7kG__content",
  "controls": "hero-slide-module__VBQ7kG__controls",
  "description": "hero-slide-module__VBQ7kG__description",
  "dot": "hero-slide-module__VBQ7kG__dot",
  "eyebrow": "hero-slide-module__VBQ7kG__eyebrow",
  "heading": "hero-slide-module__VBQ7kG__heading",
  "overlay": "hero-slide-module__VBQ7kG__overlay",
  "primaryAction": "hero-slide-module__VBQ7kG__primaryAction",
  "therapy": "hero-slide-module__VBQ7kG__therapy",
});
